const getWeekDatesDatas = (DateObj) => {
    
    let ret = [];
    const TheDate  = DateObj;//new Date(timestamp);
  //
    const OutputStartDate = new Date(TheDate.getFullYear(), TheDate.getMonth(), TheDate.getDate()-3);
    const Today = new Date();

    let LoopDay = new Date(OutputStartDate.getTime());
    let days = [];
    for(var d = 0; d < 7; d++ ){
       //console.log(LoopDay.toLocaleDateString());
        let dayname = LoopDay.toLocaleString("de-DE", {weekday:"short"});
        let showdaycss = '';
        if(LoopDay.toLocaleDateString() == Today.toLocaleDateString()){
            dayname = 'today';
        }
        if(LoopDay.toLocaleDateString() == TheDate.toLocaleDateString()){
          showdaycss = 'showday'
        }

      ret.push({
        dayid: leadingZero(LoopDay.getFullYear()) +'-'+ leadingZero(LoopDay.getMonth()+1) +'-'+ leadingZero(LoopDay.getDate()),
        dayhead: dayname,
        daynb: leadingZero(LoopDay.getDate()),
        daycontent: getDayInfos(LoopDay),
        showdaycss: showdaycss,
      });
      
      let LoopDayHelp = new Date(LoopDay.getFullYear(),LoopDay.getMonth(),LoopDay.getDate() +1);
      LoopDay.setTime(LoopDayHelp.getTime());
    }
    
    return ret
} 

const getWeekDatesDatasMonday = (DateObj) => {
    
  let ret = [];
  const TheDate  = DateObj;//new Date(timestamp);
//
  const Today = new Date();
  let dayNb = Today.getDay();
  let daySub = 0;
  if(dayNb == 0)daySub=6;
  if(dayNb > 0)daySub=dayNb-1;

  const OutputStartDate = new Date(TheDate.getFullYear(), TheDate.getMonth(), TheDate.getDate()-daySub);
  

  let LoopDay = new Date(OutputStartDate.getTime());
  let days = [];
  for(var d = 0; d < 7; d++ ){
     //console.log(LoopDay.toLocaleDateString());
      let dayname = LoopDay.toLocaleString("de-DE", {weekday:"short"});
      let showdaycss = '';
      if(LoopDay.toLocaleDateString() == Today.toLocaleDateString()){
          dayname = 'Heute';
      }
      //if(LoopDay.toLocaleDateString() == TheDate.toLocaleDateString()){
      //  showdaycss = ''
      //}

    ret.push({
      dayid: leadingZero(LoopDay.getFullYear()) +'-'+ leadingZero(LoopDay.getMonth()+1) +'-'+ leadingZero(LoopDay.getDate()),
      dayhead: dayname,
      daynb: leadingZero(LoopDay.getDate()),
      daycontent: getDayInfos(LoopDay),
      showdaycss: showdaycss,
    });
    
    let LoopDayHelp = new Date(LoopDay.getFullYear(),LoopDay.getMonth(),LoopDay.getDate() +1);
    LoopDay.setTime(LoopDayHelp.getTime());
  }
  
  return ret
} 

function getDayInfos(Date){
    return [];
}

function leadingZero(val){
    return (val < 10 ? '0' : '') + val;
}

export  {getWeekDatesDatas, getWeekDatesDatasMonday}